module.exports = __webpack_public_path__ + "img/tickets.046e4589.jpeg";